import { DefaultButton, Dialog, DialogFooter, IModalProps, IStyle, PrimaryButton, Stack, MessageBar, MessageBarType } from "@fluentui/react";
import { Guid } from "guid-typescript";
import { t } from "i18next";
import { CSSProperties, useContext, useEffect, useState } from "react";
import { Ticket } from "../../../Model/SystemModels";
import { CommonCreateTicketForm } from "../../Common/CommonCreateTicketForm/CommonCreateTicketForm";
import { ChatbotPanel } from "../../Chatbot/Chatbot";
import { EmbeddedLayout } from "../../Chatbot/layout/Layout";
import { ChatbotMessageProvider, useChatbotMessageContext, ChatbotMessageContext } from "../../../Core/State/ChatbotMessageContext";

export interface ICustomCustomerIncidentCardProps {
    showCard: boolean;
    saveInProgress: boolean;
    record: Ticket;
    customStyle?: CSSProperties;
    onCancel: () => void;
    onSave: (record: Ticket) => void;
}

export class CustomAttachment {
    id: string = Guid.create().toString();
    fileExtension: string = "";
    fileName: string = "";
    fileBlob: string = "";
}

export const CustomCustomerIncidentCard: React.FC<ICustomCustomerIncidentCardProps> = (props) =>  {
    
    return (
        <ChatbotMessageProvider key={props.showCard ? 'open' : 'closed'}>
            <CustomCustomerIncidentCardContent {...props} />
        </ChatbotMessageProvider>
    );
}

const CustomCustomerIncidentCardContent: React.FC<ICustomCustomerIncidentCardProps> = (props) =>  {
    
    const shrinkedModalIStyle: IStyle = {
        width: '59% !important',
        maxWidth: 'calc(59%) !important',
        position: 'absolute',
        top: 52,
        left: 0
    }
    
    const fullModalIStyle: IStyle = {
        width: '95% !important',
        maxWidth: 'calc(95%) !important',
        position: 'absolute',
        top: 50
    }

    const { messageCount } = useChatbotMessageContext();
    
    const [record, setRecord] = useState(new Ticket());
    const [modalStyle, setModalStyle] = useState<IStyle>(shrinkedModalIStyle);
    const [showHelpPanel, setShowHelpPanel] = useState<boolean>(true);
    const [isTitleEnabled, setIsTitleEnabled] = useState<boolean>(false);
    
    const pageCardModalProps: Partial<IModalProps> = {
        isBlocking: true,
        dragOptions: undefined,
        styles: {
            main: modalStyle
        },
        layerProps:{styles:{root:{zIndex: props.customStyle?.zIndex ? props.customStyle.zIndex : '50000 !important'}}},
    };

    useEffect(()=>{
        if(props.showCard){
            setRecord(props.record);
            setModalStyle(shrinkedModalIStyle);
            setShowHelpPanel(true);
            setIsTitleEnabled(false);
        }
    },[props.showCard]);

    useEffect(() => {
        if (messageCount >= 3 && !isTitleEnabled) {
            setIsTitleEnabled(true);
        }
    }, [messageCount, isTitleEnabled]);
    
    return (
        <Dialog 
            hidden={!props.showCard}
            modalProps={pageCardModalProps}
            onDismiss={props.onCancel}
            dialogContentProps={{
                title: t('customerCenter:CustomerIncidentList:CustomerIncidentCard:title')!
            }}>
                <CommonCreateTicketForm
                    showForm={props.showCard}
                    record={record}
                    saveInProgress={props.saveInProgress}
                    customActionEnabled={false}
                    titleDisabled={!isTitleEnabled}
                    onCreateTicket={props.onSave}
                    onClosePage={props.onCancel}
                    onSetRecord={(record:Ticket)=>setRecord(record)}
                />
                <Stack.Item key="modalFooterContent">
                    <DialogFooter>
                        <DefaultButton text={t('common:PageContainer:card:defaultButtonText')!} onClick={props.onCancel} disabled={props.saveInProgress} />
                        <PrimaryButton 
                            text={t('common:PageContainer:card:primaryButtonText')!} 
                            onClick={() => props.onSave(record)} 
                            disabled={props.saveInProgress} 
                        />
                    </DialogFooter>
                </Stack.Item>
                <ChatbotPanel
                    isOpen={showHelpPanel}
                    customStyle={{zIndex:'50000 !important'}}
                    onDismiss={() => {
                        setModalStyle(fullModalIStyle);
                        setShowHelpPanel(false);
                    }}
                >
                <EmbeddedLayout />
                </ChatbotPanel>
        </Dialog>
    );
}